// extracted by mini-css-extract-plugin
module.exports = {"container":"S04_Global_container__1f0O1","limiter":"S04_Global_limiter__3wK6O","title":"S04_Global_title__lSIOu","text":"S04_Global_text__2c0sp","sub":"S04_Global_sub__EO9a9"};